import React from 'react';
import { shape, string } from 'prop-types';
import ErrorPage from './ErrorPage';
import useStandardErrorButtons from './useStandardErrorButtons';

// for code errors and missing chunk files a page reload
// is more likely to resolve the issue than a rerender
const reloadPage = () => window.location.reload();

const GenericErrorPage = ({ error, title, message }) => {
  const buttons = useStandardErrorButtons(reloadPage);
  return <ErrorPage message={error?.message || message} buttons={buttons} title={title} />;
};

GenericErrorPage.propTypes = {
  error: shape({ message: string }),
  message: string,
  title: string,
};

export default GenericErrorPage;
